<template>
  <div class="time-line">
    <div class="header"><el-button type="primary" icon="el-icon-plus" @click="handlePlus">添 加</el-button></div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="item.time">
        <el-form size="small" label-width="110px">
          <el-form-item label="海报">
            <img v-if="item.poster" class="thumb cursor-pointer" :src="item.poster" title="点击更换" @click="selectThumb(item)">
            <div v-else class="addimg" @click="selectThumb(item)">+</div>
          </el-form-item>
          <el-form-item label="海报标题">
            <el-input v-model="item.poster_title"></el-input>
          </el-form-item>
          <el-form-item label="海报标题(英文)">
            <el-input v-model="item.poster_title_en"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="item.title"></el-input>
          </el-form-item>
          <el-form-item label="标题(英文)">
            <el-input v-model="item.title_en"></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-input v-model="item.time"></el-input>
          </el-form-item>
          <el-form-item label="时间(英文)">
            <el-input v-model="item.time_en"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" v-model="item.text" :rows="5"></el-input>
          </el-form-item>
          <el-form-item label="描述(英文)">
            <el-input type="textarea" v-model="item.text_en" :rows="5"></el-input>
          </el-form-item>
          <el-form-item label="人物">
            <el-select v-model="item.people" multiple filterable placeholder="请选择" style="width:350px;">
              <el-option
                v-for="item in people"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电影">
            <el-select v-model="item.movie" multiple filterable placeholder="请选择" style="width:350px;">
              <el-option
                v-for="item in movie"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片">
            <el-button type="primary" @click="editImageCom(index)" size="small">编辑</el-button>
          </el-form-item>
          </el-form-item>
          <el-form-item label="图片标题">
            <el-input v-model="item.picture_title"></el-input>
          </el-form-item>
          <el-form-item label="图片标题(英文)">
            <el-input v-model="item.picture_title_en"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="text" @click="handleup(index)">上移</el-button>
            <el-button type="text" @click="handledown(index)">下移</el-button>
            <el-button type="text" @click="handleDelete(index)">删除</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bottom"><el-button type="primary" @click="onSubmit">保 存</el-button></div>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>

    <!-- 图片组件 -->
    <el-dialog title="编辑图片组件" :visible.sync="imageComVisible" width="1110px">
      <ImageCom v-if="imageComVisible" @save="saveImageCom"  :com="imageCom"></ImageCom>
    </el-dialog>

  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'

import ImageCom from "@/components/ImageCom"

export default {
  name: 'timeLine',
  components: {
    UploadImg,
    ImageCom
  },
  data () {
    return {
      people: [],
      movie: [],
      imageCom: {},
      currentIndex: 0,
      list: [
        {
          poster: '',
          poster_title: '',
          title: '',
          time: '',
          text: '',
          people: [],
          movie: [],
          image_com: []
        }
      ],
      imageComVisible: false
    }
  },
  created () {
    this.getPeople()
    this.getMovie()
    this.getTimeLine()
  },
  methods: {
    saveImageCom (val) {
      this.list[this.currentIndex].image_com = val

      this.imageComVisible = false
    },
    editImageCom (index) {
      this.imageCom = this.list[index].image_com
      this.currentIndex = index

      this.imageComVisible = true
    },
    handlePlus () {
      this.list.push({
        poster: '',
        poster_title: '',
        title: '',
        time: '',
        text: '',
        people: [],
        movie: []
      })
    },
    handledown (index) {
      if (index === this.list.length - 1) return
      let next = this.list[index + 1]
      this.list.splice(index + 1, 1)
      this.list.splice(index, 0, next)
    },
    handleup (index) {
      if (index === 0) return
      let pre = this.list[index - 1]
      this.list.splice(index - 1, 1)
      this.list.splice(index, 0, pre)
    },
    handleDelete (index) {
      this.list.splice(index, 1)
    },
    onSubmit () {
      request({
        url: '/ui/movie/timeline',
        method: 'put',
        data: {
          timeline: this.list
        }
      }).then(res => {
        this.$message.success('保存成功')
      })
    },
    getTimeLine () {
      request({
        url: '/ui/movie/timeline'
      }).then(res => {
        this.list = res.data.timeline || []
      })
    },
    getPeople () {
      request({
        url: '/movie/people'
      }).then(res => {
        this.people = res.data.list
      })
    },
    getMovie () {
      request({
        url: '/movie'
      }).then(res => {
        this.movie = res.data.list
      })
    },
    selectThumb (item) {
      let list = []
      if (item.poster) {
        list = [item.poster]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          item.poster = res[0]
        }
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
.time-line {
  .addimg {
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #666;
    font-size: 17px;
    border: 1px dashed #999999;
    cursor: pointer;
  }
  .thumb {
    height: 50px;
    width: auto;
  }
  .list {
    margin-top: 20px;
    width: 700px;
    .item {
      margin-bottom: 20px;
      padding: 10px 20px;
      background-color: #f8f8f8;
      /deep/ .el-form-item {
        margin-bottom: 8px;
      }
    }
    .add-btn {
      width: 70px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      border-radius: 5px;
      border: 1px dashed #dddddd;
      cursor: pointer;
    }
  }
  .bottom {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/timeLine.vue